<template>
  <icon-base
    :title="title"
    :name="name"
    :viewbox="viewBox">
    



<g>
	<path d="M12,23.25C5.797,23.25,0.75,18.203,0.75,12C0.75,5.797,5.797,0.75,12,0.75c6.203,0,11.25,5.047,11.25,11.25
		C23.25,18.203,18.203,23.25,12,23.25z M12,2.25c-5.376,0-9.75,4.374-9.75,9.75s4.374,9.75,9.75,9.75s9.75-4.374,9.75-9.75
		S17.376,2.25,12,2.25z"/>
	<path d="M16.687,17.438c-0.2,0-0.389-0.078-0.53-0.22l-4.687-4.688c-0.07-0.07-0.125-0.152-0.163-0.245
		c-0.003-0.008-0.006-0.017-0.009-0.025c-0.032-0.086-0.047-0.172-0.047-0.26V8.25c0-0.414,0.336-0.75,0.75-0.75
		s0.75,0.336,0.75,0.75v3.439l4.467,4.468c0.142,0.142,0.22,0.33,0.22,0.53s-0.078,0.389-0.22,0.53S16.887,17.438,16.687,17.438z"/>
</g>


  </icon-base>
</template>

<script>
import IconBase from '../IconBase';

export default {
  components: {
    IconBase,
  },
  props: {
    title: {
      type: String,
      required: false,
      default: 'time-clock-circle',
    },
    name: {
      type: String,
      required: false,
      default: 'TimeClockCircle',
    },
    viewBox: {
      type: String,
      required: false,
      default: '0 0 24 24',
    },
  },
};
</script>

<style scoped>
  
</style>